var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecurityAccessLow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 98,
    viewBox: "0 0 108 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 49.4999L30.25 46.4688V52.531L19 49.4999Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7659_16666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 108,
    height: 78
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 0H0V78H108V0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7659_16666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.186 96.372C78.5893 96.372 98.372 76.5893 98.372 52.186C98.372 27.7827 78.5893 8 54.186 8C29.7827 8 10 27.7827 10 52.186C10 76.5893 29.7827 96.372 54.186 96.372Z",
    stroke: "#E8EBEF",
    strokeWidth: 6.16549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.03 10.28"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7659_16666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 46,
    width: 25,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46H0V78H25V46Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7659_16666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.372 52.186C98.372 76.5893 78.5893 96.372 54.186 96.372C29.7828 96.372 10 76.5893 10 52.186C10 27.7828 29.7828 8 54.186 8C78.5893 8 98.372 27.7828 98.372 52.186Z",
    stroke: "#FF0055",
    strokeWidth: 6.16549,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.03 10.28"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8479 50.5001C79.8479 36.5009 68.4993 25.1523 54.5001 25.1523C40.5009 25.1523 29.1523 36.5009 29.1523 50.5001C29.1523 64.4993 40.5009 75.8479 54.5001 75.8479C68.4993 75.8479 79.8479 64.4993 79.8479 50.5001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.375 48.5H50.375C49.8777 48.5 49.4008 48.3025 49.0492 47.9508C48.6976 47.5992 48.5 47.1223 48.5 46.625C48.5 46.1277 48.6976 45.6508 49.0492 45.2992C49.4008 44.9475 49.8777 44.75 50.375 44.75H63.375C63.5408 44.75 63.6998 44.8158 63.817 44.9331C63.9342 45.0503 64 45.2092 64 45.375V47.875C64 48.0408 63.9342 48.1997 63.817 48.3169C63.6998 48.4342 63.5408 48.5 63.375 48.5Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.375 43.5H54.75V42.25C54.75 41.9185 54.6183 41.6005 54.3839 41.3661C54.1495 41.1317 53.8315 41 53.5 41H47.25C46.9185 41 46.6006 41.1317 46.3661 41.3661C46.1317 41.6005 46 41.9185 46 42.25V59.75C46 60.0815 46.1317 60.3995 46.3661 60.6339C46.6006 60.8683 46.9185 61 47.25 61H53.5C53.8315 61 54.1495 60.8683 54.3839 60.6339C54.6183 60.3995 54.75 60.0815 54.75 59.75V49.75H50.375C49.5462 49.75 48.7514 49.4208 48.1653 48.8347C47.5793 48.2487 47.25 47.4538 47.25 46.625C47.25 45.7962 47.5793 45.0013 48.1653 44.4153C48.7514 43.8292 49.5462 43.5 50.375 43.5ZM50.375 53.5C50.7334 53.5007 51.0806 53.6247 51.3585 53.851C51.6364 54.0773 51.828 54.3923 51.9013 54.7431C51.9745 55.0939 51.925 55.4593 51.7609 55.7779C51.5968 56.0965 51.3282 56.349 51 56.4931V57.875C51 58.0408 50.9342 58.1997 50.817 58.3169C50.6998 58.4342 50.5408 58.5 50.375 58.5C50.2093 58.5 50.0503 58.4342 49.9331 58.3169C49.8159 58.1997 49.75 58.0408 49.75 57.875V56.4931C49.4219 56.349 49.1533 56.0965 48.9892 55.7779C48.8251 55.4593 48.7755 55.0939 48.8488 54.7431C48.922 54.3923 49.1137 54.0773 49.3915 53.851C49.6694 53.6247 50.0166 53.5007 50.375 53.5Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8479 50.5001C79.8479 36.5009 68.4993 25.1523 54.5001 25.1523C40.5009 25.1523 29.1523 36.5009 29.1523 50.5001C29.1523 64.4993 40.5009 75.8479 54.5001 75.8479C68.4993 75.8479 79.8479 64.4993 79.8479 50.5001Z",
    stroke: "#333333",
    strokeWidth: 2.30435
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurityAccessLow);
export default __webpack_public_path__ + "static/media/icon-security-access-low.6c149c5892c467640aada16cf0fa98ae.svg";
export { ForwardRef as ReactComponent };